module.exports = __webpack_public_path__ + "img/wellcome_google.07b8d359.png";